// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3u5Iv","notificationBadge":"style_notificationBadge__3tXen","open":"style_open__1QqSq","icon":"style_icon__12hVK"};